import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { SearchIcon, PlayCircleIcon, SunriseIcon } from 'lucide-react';
const steps = [{
  num: '01',
  icon: SearchIcon,
  title: 'Identifica',
  desc: 'Usa la guía para seleccionar el magnesio correcto y eliminar los que te dañan.',
  color: '#4ECDC4'
}, {
  num: '02',
  icon: PlayCircleIcon,
  title: 'Implementa',
  desc: 'Sigue el ritual de 10 minutos justo antes de apagar la luz.',
  color: '#D4A853'
}, {
  num: '03',
  icon: SunriseIcon,
  title: 'Repara',
  desc: 'Despierta con claridad mental y los músculos recuperados tras una noche de sueño real.',
  color: '#4ECDC4'
}];
export function HowItWorks() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #0D1330 0%, #111840 100%)'
  }} data-id="element-81">
      <div className="max-w-5xl mx-auto" data-id="element-82">
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-12 text-center" data-id="element-83">
          Cómo <span className="text-[#D4A853]" data-id="element-84">funciona</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-85">
          {/* Connecting line (desktop) */}
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-px bg-gradient-to-r from-[#4ECDC4]/30 via-[#D4A853]/30 to-[#4ECDC4]/30" data-id="element-86" />

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="text-center relative" data-id="element-87">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 relative z-10" style={{
            background: `${step.color}15`,
            border: `2px solid ${step.color}40`
          }} data-id="element-88">
                <step.icon className="w-7 h-7" style={{
              color: step.color
            }} data-id="element-89" />
              </div>
              <span className="font-display text-sm font-bold tracking-widest" style={{
            color: step.color
          }} data-id="element-90">
                PASO {step.num}
              </span>
              <h3 className="text-white font-bold text-xl mt-2 mb-3" data-id="element-91">
                {step.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto" data-id="element-92">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </AnimatedSection>;
}